import { yupResolver } from '@hookform/resolvers/yup';
import { type Resolver } from 'react-hook-form';
import * as yup from 'yup';

import ERROR_MESSAGE from '@/constants/errors.constants';

export type Form = {
	nifEmisor: string;
	idError: number;
	idTramite: number;
	idTipoError: number;
	numeroTramite: string;
	fechaCreacion: string;
	observacionesPeticion: string;
	observacionesEmisor: string;
	notSubsanacion: Array<'true'>;
};

export const defaultValues = {
	nifEmisor: '',
	numeroTramite: '',
	fechaCreacion: undefined,
	observacionesPeticion: '',
	observacionesEmisor: '',
	notSubsanacion: [],
};

export const schema = yup.object().shape({
	observacionesEmisor: yup.string().when('notSubsanacion', {
		is: (val: Form['notSubsanacion']) => Boolean(val?.includes('true')),
		then: (schema) => schema.required(ERROR_MESSAGE.required),
		otherwise: (schema) => schema.nullable(),
	}),
});

export const getSchema = (): Resolver<any> => yupResolver(schema);